import { useEffect, useRef, useState } from "react";
import axiosInstance from "src/common/axiosInstance";

export default function ActivityReminderPanel({ activityId, onClose }) {
  const [page, setPage] = useState(1);
  const [refresh, setRefresh] = useState(0);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const heading = useRef(null);
  useEffect(() => {
    let current = true;
    setResult(null);
    setError("");
    heading.current?.focus();
    axiosInstance.get(`/lead-activities/${activityId}/reminders`, { params: { page } }).then(({ data }) => {
      if (current) setResult(data);
    }).catch(failure => {
      if (current) setError([401, 403].includes(failure.response?.status)
        ? "Your account cannot view reminder plans. Check your Auto Appy sign-in and access."
        : "Reminder plans are unavailable. Refresh to try again; this does not mean there are no reminders.");
    });
    return () => { current = false; };
  }, [activityId, page, refresh]);
  return <section aria-label="Activity reminders" className="rounded-2xl border border-blue-200 bg-white p-5 space-y-4">
    <div className="flex items-center justify-between gap-3">
      <h3 ref={heading} tabIndex={-1} className="font-semibold">Reminders · Activity {activityId}</h3>
      <button type="button" onClick={onClose} className="rounded border px-3 py-2">Close reminders</button>
    </div>
    <p className="text-sm text-slate-600">Your verified follow-up plans for this activity. Plans owned by teammates and drafts without a verified activity link are not included. This view refreshes only when opened or requested.</p>
    {!result && !error && <p role="status">Loading reminders…</p>}
    {error && <p role="alert" className="text-red-700">{error}</p>}
    {result?.scope === "not_connected" ? <p>This CRM workspace is not connected to Auto Appy reminders. CRM activities still work independently.</p> : result && <>
      {!result.data.length && <p>No verified plans visible to your account for this activity.</p>}
      <ul className="space-y-3">{result.data.map(plan => <li key={plan.id} className="rounded-xl border border-slate-200 p-3">
        <div className="flex justify-between gap-3"><strong>{plan.name}</strong><span className="rounded bg-slate-100 px-2 py-1 text-xs capitalize">{plan.status}</span></div>
        <p className="mt-2 text-sm text-slate-600">{plan.next_run_at ? `Next pending run: ${new Date(plan.next_run_at).toLocaleString()}` : "No pending run scheduled"}</p>
      </li>)}</ul>
      {(page > 1 || result.has_more) && <div className="flex items-center gap-3">
        <button type="button" disabled={page === 1} onClick={() => setPage(value => value - 1)}>Previous</button>
        <span>Page {page}</span>
        <button type="button" disabled={!result.has_more} onClick={() => setPage(value => value + 1)}>Next</button>
      </div>}
    </>}
    <button type="button" disabled={!result && !error} onClick={() => setRefresh(value => value + 1)} className="rounded border px-3 py-2 disabled:opacity-50">Refresh reminders</button>
  </section>;
}
